import styled from 'styled-components';
import { FlexColumn } from '../../utils/containers';

const LandingPageStyle = styled(FlexColumn)`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 64px;
`;

export default LandingPageStyle;
